module.exports = __webpack_public_path__ + "img/14.ab53a1ba.gif";